import {CollectionFactory, Reducer} from '@modifi/redux'
import {
  getAuthenticatedThemisClient,
  ExistingFinancialDataSetView,
} from '@modifi/onboarding-api-clients'
import {createSelector} from 'reselect'

import {getSortedFinacialDocBySection} from './utils'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = CollectionFactory({
  actionNamePrefix: 'data/financial-data-set/collection',
  reducerPath: ['data', 'financialDataSet', 'collection'],
  entityPrimaryKeySelector: (entity: ExistingFinancialDataSetView) => entity.externalId!,
  fetchRequest: () =>
    apiClient.CompanyFinancials.fetch().then(res => res.data()?.financialDataSets || []),
})

export default reducer as Reducer

export const aFetchFinancialDataSet = (): any => actions!.fetch('all')

export const selectFinancialDataSet = (
  state: Record<string, any>
): ExistingFinancialDataSetView[] =>
  selectors.selectByKeyWindow(state, 'all') as ExistingFinancialDataSetView[]

export const selectSortedFinacialDocBySection = createSelector(
  selectFinancialDataSet,
  (state: Record<string, any>, sectionName: string) => sectionName,
  (financialDataSet, sectionName) =>
    financialDataSet ? getSortedFinacialDocBySection(financialDataSet, sectionName) : []
)

export const selectFinancialDataSetPending = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, 'all')
